export default "__VITE_ASSET__CFyQSA2Q__"